module.exports = __webpack_public_path__ + "img/36234-011.e80acc54.jpg";